import { useState } from "react";
import {
  formatSocialMentions,
  generateCardData,
  buttonLabels,
} from "../utils/data";
import { useAgentData, useChatPageData } from "../utils/hooks";
import SelectedMention from "../socialMediaComp/SelectedMention";
import {
  FilterButton,
  Loader,
  SearchInput,
  SummaryCardGrid,
  TabButtonGroup,
} from "../components/shared";
import useMediaQuery from "../utils/hooks/useMediaQuery";
import { useOutletContext } from "react-router-dom";

const SocialMedia = () => {
  const [selectedIndex, setSelectedIndex] = useState(4);

  const {
    dashboardSummary,
    socialMentions,
    loading: summaryLoading,
  } = useAgentData();
  const { loading: chatLoading } = useChatPageData();

  const isMdUp = useMediaQuery("(min-width: 768px)");
  const SocialMediaMentionsItems = formatSocialMentions(socialMentions);
  const cardData = dashboardSummary ? generateCardData(dashboardSummary) : [];
  const { toggleSidebar } = useOutletContext();

  if (summaryLoading || chatLoading || !socialMentions) {
    return (
      <div className="w-full h-[calc(100vh-100px)] flex items-center justify-center">
        <Loader size={40} color="black" />
      </div>
    );
  }
  return (
    <div className="flex flex-row min-h-[calc(100vh-100px)] w-full">
      {/* Left Panel */}
      <div className="flex flex-col w-full h-auto gap-2 lg:gap-2">
        <div className="w-full justify-between h-[22px] border-b pr-1 border-[#0000002B] flex items-center">
          <h1 className="h-[24px] text-[13px] font-semibold leading-[100%] text-black font-inter">
            Social Media Management
          </h1>

          <div className="flex flex-row items-center gap-2 pb-4">
            <div className="border-[#0000002B] rounded-[2px] border shadow-[4px_4px_47.1px_0px_#00000040] bg-white p-[3px]">
              <img
                src="/icons/solar.png"
                alt="icon"
                className="w-[15px] h-[15px] object-contain cursor-pointer bg-white"
              />
            </div>
            {/* Menu button visible only on small screens */}
            <button
              onClick={toggleSidebar}
              className="md:hidden px-3 py-1 text-[10px] font-medium text-black border border-[#0000002B] rounded-md hover:bg-black-700 transition"
            >
              Menu
            </button>
          </div>
        </div>

        <TabButtonGroup
          buttonLabels={buttonLabels}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
        <SummaryCardGrid data={cardData} />

        {/* Search and Filter */}
        <div className="flex flex-row items-center justify-between w-full">
          <SearchInput placeholder="Search Customers .." />
          <div className="flex flex-row">
            <div
              className="flex items-center justify-end cursor-pointer"
              onClick={""}
            >
              <div className="w-50 h-6 rounded-[7px] bg-[#E5E6E7] px-2 flex items-center justify-between gap-2">
                <img
                  src={"/icons/calender.png"}
                  alt={"calendar"}
                  className="w-[16px] h-[16px]"
                />
                <span className="font-inter font-semibold text-[9px] leading-[100%] tracking-[0%] text-black truncate max-w-[100px]">
                  May 5, 2023 - May 15, 2023
                </span>
              </div>
            </div>
            <FilterButton
              className="pr-2 ml-2"
              onClick={() => "Tags Filter Clicked"}
            />
          </div>
        </div>

        {/* Mentions List */}
        <div className="flex-1 w-full h-full pr-2">
          <div className="w-full flex-1 h-full shadow-[4px_4px_47.1px_0px_#00000040] rounded-[10px] pt-1 overflow-hidden">
            <div className="flex flex-col h-full gap-0 mt-2 overflow-y-auto">
              <div className="w-full border-b pb-2 pl-3 border-[#0000002B] flex flex-row items-center justify-between">
                <span className="w-full text-[12px] font-semibold font-inter leading-[100%] text-black">
                  Social Media Management
                </span>
                <div className="flex flex-row items-center gap-4 pr-3">
                  <img
                    src={"/icons/flowbite.png"}
                    alt={"calendar"}
                    className="w-[16px] h-[16px]"
                  />
                  <img
                    src={"/icons/refresh.png"}
                    alt={"calendar"}
                    className="w-[16px] h-[16px]"
                  />
                </div>
              </div>

              {SocialMediaMentionsItems.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col items-start w-full gap-3 px-3 pt-5"
                >
                  <div className="flex flex-row items-start w-full gap-3">
                    <div
                      className={`w-[26px] h-[26px] ${item.bgColor} rounded-full flex items-center justify-center`}
                    >
                      <img
                        src={item.icon}
                        alt="icon"
                        className="w-[15px] h-[15px] object-contain"
                      />
                    </div>

                    <div className="flex flex-col w-full">
                      <div className="flex items-center justify-between w-full">
                        <span className="text-[12px] font-semibold font-inter leading-[100%] text-black">
                          {item.username}
                        </span>
                        <span className="text-[9.5px] font-medium font-inter leading-[100%] text-[#00000073] px-2 py-0.5 rounded">
                          {item.timestamp}
                        </span>
                      </div>
                      <div className="text-[9.5px] py-1 font-inter text-[#00000073] text-opacity-80">
                        {item.message}
                      </div>
                      <div className="flex flex-row gap-x-2">
                        <div className="flex flex-row items-center">
                          <img
                            src="/icons/reply.png"
                            alt="reply"
                            className="w-[15px] h-[15px] object-contain"
                          />
                          <span className="text-[9.5px] font-medium font-inter text-[#00000073] px-2 py-0.5 rounded">
                            Reply
                          </span>
                        </div>
                        <div className="flex flex-row items-center">
                          <img
                            src="/icons/like.png"
                            alt="like"
                            className="w-[12px] h-[12px] object-contain"
                          />
                          <span className="text-[9.5px] font-medium font-inter text-[#00000073] px-2 py-0.5 rounded">
                            Like
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel – Only on md and up */}
      {isMdUp && (
        <div className="border-[#0000002B] w-[26%] border-l">
          <SelectedMention />
        </div>
      )}
    </div>
  );
};

export default SocialMedia;
